import React from "react";
import { FC } from "react";
import { useSelector } from "react-redux";

import HooksService, { HookKeys } from "@services/hooks.services";
import { ProductImpressionModel } from "@services/tracking";

import { useThunkDispatch } from "@redux/dispatcher";
import {
    addProduct,
    removeProduct,
} from "@redux/modules/api/data/wishlist/wishlist.module";
import { getWishlists } from "@redux/modules/api/data/wishlist/wishlist.selectors";

import WishlistButton from "./WishlistButton.component";

export interface WishlistButtonContainerProps {
    sku: string;
    trackingProduct: ProductImpressionModel;
    withReload?: boolean;
    className?: string;
    iconSize?: string;
    label?: (isProductInWishlist: boolean) => string;
    labelClassName?: string;
}

export const WishlistButtonContainer: FC<WishlistButtonContainerProps> = ({
    sku,
    trackingProduct,
    withReload,
    className,
    iconSize,
    label,
    labelClassName,
}) => {
    const wishlists = useSelector(getWishlists);
    const dispatch = useThunkDispatch();

    const addToWishlist = () => {
        return dispatch(addProduct(sku, trackingProduct));
    };

    const removeFromWishlist = () => {
        return dispatch(removeProduct(sku, withReload));
    };

    return (
        <WishlistButton
            className={className}
            addToWishlist={addToWishlist}
            removeFromWishlist={removeFromWishlist}
            label={label}
            labelClassName={labelClassName}
            sku={sku}
            wishlists={wishlists}
            iconSize={iconSize}
        />
    );
};
